import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import moment from 'moment';

import styles from "./ChatTranscriptTable.module.css";

interface ChatTranscriptItem {
    conversationID: string;
    question: string;
    timeStamp: string;
}

interface ChatTranscriptList extends Array<ChatTranscriptItem> {}

interface Props {
    chatTranscriptList: ChatTranscriptList;
}

const ChatTranscriptTable = ({ chatTranscriptList }: Props) => {
    const [itemsPerPage, setitemsPerPage] = useState(5);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [currentItems, setCurrentItems] =
        useState<ChatTranscriptList>(chatTranscriptList);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(chatTranscriptList.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(chatTranscriptList.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, chatTranscriptList]);

    const handlePageClick = (event: any) => {
        const newOffset =
            (event.selected * itemsPerPage) % chatTranscriptList.length;
        setItemOffset(newOffset);
    };

    return (
        <div>
            <div className={`${styles.tableContainer} p-3 m-3`}>
                <div className={`${styles.clientList} mt-4`}>
                    <table className={`${styles.table} w-100`}>
                        <thead className={styles.tableHead}>
                            <tr>
                                <th className="ps-5 text-left">Question</th>
                                <th className="p-1 text-center">Timestamp</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((item, index) => (
                                <tr
                                    className={`${styles.tableRow} border-bottom`}
                                    key={index}
                                >
                                    <td className="ps-5 text-left">
                                        {item.question}
                                    </td>
                                    <td className={"p-3 text-center"}>
                                        {moment(item.timeStamp).format("h:mma DD MMM, YYYY")}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="row p-0 m-0 mt-4">
                    <div className="col-auto px-2 d-flex align-items-center">
                        Rows Per Page
                    </div>
                    <div className="col-auto px-2 d-flex align-items-center">
                        <button
                            className={`btn ${styles.dropdownToggle}`}
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {itemsPerPage}
                        </button>
                        <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                        >
                            <li>
                                <div
                                    className={styles.dropdownItem}
                                    onClick={() => setitemsPerPage(5)}
                                >
                                    5
                                </div>
                            </li>
                            <li>
                                <div
                                    className={styles.dropdownItem}
                                    onClick={() => setitemsPerPage(10)}
                                >
                                    10
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="col p-0 d-flex justify-content-end">
                        <ReactPaginate
                            nextLabel=">"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={4}
                            marginPagesDisplayed={2}
                            pageCount={pageCount}
                            previousLabel="<"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakLabel="..."
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            containerClassName="pagination"
                            activeClassName="active"
                            renderOnZeroPageCount={null}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatTranscriptTable;
